var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"notification",staticClass:"columns"},[_c('div',{staticClass:"column is-full"},[_c('div',{staticClass:"notification has-text-centered",class:_vm.className},[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }